'use strict';

import angular from 'angular';

export default class MemAtrTypeFormCtrl {
  model = {
    name: '',
    isActive: true
  };
  // Auth; //TODO: add auth check

  constructor($state, $stateParams, LoaderSvc, MemAtrTypeSvc, GroupAuthSvc) {
    var groupId = $stateParams.groupId;
    this.groupId = groupId;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.MemAtrTypeSvc = MemAtrTypeSvc;
    this.LoaderSvc = LoaderSvc;

    var that = this;

    this.isCreate = $state.current.name.indexOf('new') !== -1;
    // create
    if(this.isCreate) {
      // authorization
      GroupAuthSvc.validatePermission(groupId, 'memberAttributeType', 'C');

      this.submit = this.createMemAtrType;
      this.headerText = 'New Member Attribute';
      this.submitText = 'Create Member Attribute';
      this.cancelSref = 'group.view.settings.memberAttributeType.list';

    // edit
    } else {
      // authorization
      GroupAuthSvc.validatePermission(groupId, 'memberAttributeType', 'U');

      this.submit = this.updateMemAtrType;
      var maId = $stateParams.maId;
      this.maId = maId;
      this.headerText = 'Edit Member Attribute';
      this.submitText = 'Update Member Attribute';
      this.MemAtrTypeSvc.get({groupId, id: maId}).$promise
        .then(function(ma) { that.model = angular.copy(ma); });
      this.cancelSref = 'group.view.settings.memberAttributeType.list';
    }
  }

  createMemAtrType() {
    var that = this;
    that.LoaderSvc.start();
    var model = that.model;
    model.definedByGroupId = Number(that.groupId);
    that.MemAtrTypeSvc.create({groupId: that.groupId}, this.model).$promise
      .then(function(ma) {
        that.LoaderSvc.stopSuccess('Member Attribute Created');
        that.$state.go('group.view.settings.memberAttributeType.list',
          {maId: ma.id});
      }).catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }

  updateMemAtrType() {
    var that = this;
    that.LoaderSvc.start();

    this.MemAtrTypeSvc
      .update({groupId: that.groupId, id: that.maId}, this.model).$promise
      .then(function() {
        that.$state
          .go(
            'group.view.settings.memberAttributeType.list',
            {maId: that.maId}
          );
        that.LoaderSvc.stopSuccess('Member Attribute Updated');
      })
      .catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }
}

MemAtrTypeFormCtrl.$inject = [
  '$state',
  '$stateParams',
  'LoaderSvc',
  'MemAtrTypeSvc',
  'GroupAuthSvc'
];
